import styles from "./HideReviewedToggle.module.css";

export const HideReviewedToggle = ({ value, onChange }) => (
  <label className={styles.hideReviewedToggle}>
    <span
      className={`${styles.toggleTrack} ${value ? styles.toggleTrackOn : ""}`}
      onClick={() => onChange(!value)}
    >
      <span className={styles.toggleThumb} />
    </span>
    <span className={styles.toggleLabel}>Hide reviewed</span>
  </label>
);
